import React from "react";

import Header from "../components/ContainerHeader";
import Form from "../components/hostFound/Form";

const HostFound = ({ history }) => {
  return (
    <div className="flex-col">
      <Header title="Založit nového hostitele" />
      <Form history={history} />
    </div>
  );
};

export default HostFound;



// WEBPACK FOOTER //
// ./src/pages/HostFound.js